import SwitchDisplayType from './SwitchDisplayType';

export default SwitchDisplayType;